import * as React from "react";
import { RemovalTaskScheduled } from "@graffer-inc/cloud-gov-core";
import { BaseModal } from "../../../atoms/base-modal";
import dayjs, { formatDatetime } from "../../../../utils/date-utils";

type Props = {
  children?: never;
  event: RemovalTaskScheduled;
  onClose: () => void;
};

export const RemovalTaskScheduledModal: React.FC<Props> = ({
  event,
  onClose,
}) => {
  const username =
    event.createdBy.userType === "CitizenUser"
      ? "申請者"
      : event.createdBy.name || "職員";

  return (
    <BaseModal isActive title="申請削除タスクの詳細" onClose={onClose}>
      <section className="modal-card-body">
        <div className="message">
          <div className="message-body">
            <table>
              <tbody>
                <Row title="ID" content={event.data.taskId} />
                <Row
                  title="登録日時"
                  content={formatDatetime(event.createdAt)}
                />
                <Row title="登録者" content={username} />
                <Row
                  title="削除予定日"
                  content={dayjs
                    .unix(event.data.scheduledRemoveUnixtime)
                    .format("YYYY/MM/DD")}
                />
                <Row title="削除理由" content={event.data.reason} />
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-fullwidth" onClick={onClose}>
          閉じる
        </button>
      </footer>
    </BaseModal>
  );
};

const Row = (props: { title: string; content?: string }) => {
  return (
    <tr>
      <th style={{ width: 100 }}>{props.title}</th>
      <td
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-all",
        }}
      >
        {props.content}
      </td>
    </tr>
  );
};
